'use client';

import { isBrowser } from '@/app/utils/browser';
import {
  ACCEPT_7_DAYS_SECONDS,
  buildSplashAcceptKey,
} from '@/services/splash/constants';
import type { SplashPopup } from '@/services/splash/types';

export const isSplashActiveNow = (
  splash?: Pick<SplashPopup, 'beginDate' | 'endDate'> | null,
  nowMs: number = Date.now()
): boolean => {
  if (!splash) return false;

  const startMs = Date.parse(
    typeof splash.beginDate === 'string' ? splash.beginDate : ''
  );
  const endMs = Date.parse(
    typeof splash.endDate === 'string' ? splash.endDate : ''
  );

  if (Number.isNaN(startMs) || Number.isNaN(endMs)) return false;

  return startMs <= nowMs && nowMs < endMs;
};

export const readSplashAccepted = (splash: SplashPopup): boolean => {
  if (!isBrowser) return false;
  const acceptKey = buildSplashAcceptKey(splash);
  return document.cookie
    .split(';')
    .some((c) => c.trim() === `${acceptKey}=true`);
};

export const writeSplashAccepted = (splash: SplashPopup): void => {
  if (!isBrowser) return;

  const acceptKey = buildSplashAcceptKey(splash);
  const isHttps = window.location.protocol === 'https:';
  const secure = isHttps ? '; Secure' : '';
  const expires = new Date(
    Date.now() + ACCEPT_7_DAYS_SECONDS * 1000
  ).toUTCString();

  document.cookie = `${acceptKey}=true; path=/; Max-Age=${ACCEPT_7_DAYS_SECONDS}; Expires=${expires}; SameSite=Lax${secure}`;
};
